import { render, staticRenderFns } from "./factory_info.vue?vue&type=template&id=0c561ecf&scoped=true"
import script from "./factory_info.vue?vue&type=script&lang=js"
export * from "./factory_info.vue?vue&type=script&lang=js"
import style0 from "./factory_info.vue?vue&type=style&index=0&id=0c561ecf&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c561ecf",
  null
  
)

export default component.exports